import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import { toast } from "@msuite/ui/toast";
import { guardString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";
import React from "react";
import { authClient } from "@/api/auth";

export function RowActions({ cell }: CellContext<Tables<"users">, "actions">) {
	/** Hooks */
	const { t } = useTranslation();
	const userId = cell.row.original.id;

	/** Functions */
	function handleOnNavgateToUser() {
		window.open(`/users/${userId}`);
	}

	async function handleOnResendVerificationEmail() {
		try {
			if (!userId) return;
			await authClient.sendVerificationEmail({
				email: guardString(cell.row.original.email),
			});
			toast.success(t("users.verification_email_sent"));
		} catch (error) {
			console.error(error);
			toast.error(t("general.something_went_wrong"));
		}
	}

	/** Render */
	return (
		<React.Fragment>
			<RowActionsWrapper to={`/users/${userId}`}>
				<Menu
					items={() => [
						{
							label: t("general.open"),
							icon: icon("Info"),
							onClick: handleOnNavgateToUser,
						},
						"divider",
						{
							label: t("users.resend_verification_email"),
							icon: icon("Mail"),
							isDisabled: cell.row.original.emailVerified,
							onClick: handleOnResendVerificationEmail,
						},
					]}
				>
					<Button
						size="xxs"
						icon={<Icon name="EllipsisVertical" />}
						variant="ghost"
					/>
				</Menu>
			</RowActionsWrapper>
		</React.Fragment>
	);
}
